
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BreadcrumbService } from 'src/app/shared/services/breadcrum.service';
import { AuthService } from 'src/app/shared/services/auth.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  currentUserSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit() {
    this.authService.clearUserFromLocalStorage();
    this.activatedRoute.queryParams.subscribe(params => {
      const cfid = params['cfid'];
      if (cfid) {
        this.authService.login(cfid);
      } else {
        window.location.href = environment.logoutRedirectUrl;
      }
    });
    this.breadcrumbService.setBreadcrumb(this.activatedRoute);
  }

}
